import React from 'react';
import classNames from 'classnames';
import Link from 'gatsby-link';

import styles from './navbar.module.scss';
const MENU_ICON = <svg fill="currentcolor" height="24" viewBox="0 0 24 24"
                       width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
</svg>;


export class Navbar extends React.Component {
    constructor(...args) {
        super(...args);
        this.toggle = this.toggle.bind(this);
        this.state = {expanded: false};
    }

    render() {
        const {placement, className, children, ...props} = this.props;
        const {expanded} = this.state;
        const _className = classNames(styles.navbar, placement, className);
        return <div className={_className} {...props}>
            <div className={styles.nav}>
                <NavbarMenu expanded={expanded}
                            toggle={this.toggle}
                            hide={()=>this.setState({expanded:false})}>
                    {children}
                </NavbarMenu>
            </div>
        </div>;
    }

    toggle() {
        this.setState({expanded:!this.state.expanded});
    }
}


function NavbarMenu({expanded, toggle, hide, children}) {
    const _className = classNames(
        styles.menu,
        expanded ? styles['menu--expanded'] : styles['menu--collapsed']);
    return <div className={_className}>
        <button className={styles.MenuToggle} onClick={toggle}>
            {MENU_ICON}
        </button>
        <div className={styles.menu__links} onClick={hide}>
            {children}
        </div>
    </div>;
}


export function NavItem({children, className, active, disabled, ...props}) {
    return <div className={classNames(styles.menu__item, {active}, className)}>
        <Link className={classNames(styles.menu__link, {disabled})} {...props}>
            {children}
        </Link>
    </div>;
}



// WEBPACK FOOTER //
// ./src/ui/navbar/index.js